module.exports = __webpack_public_path__ + "fonts/ZingScriptRustR-Base.45af0edc.woff2";